/* ======================================================================== */
/* 16. sectionFeatures */
/* ======================================================================== */
var SectionFeatures = function () {

	var $target = $('.section-features[data-os-animation]'),
		$heading = $('.figure-feature__header h3'),
		$text = $('.figure-feature__header p'),
		$icon = $('.figure-feature__icon'),
		splitDescr = splitLines($text),
		splitHeading = splitLines($heading),
		tl = new TimelineMax();

	prepare();

	function prepare() {

		if (!$target.length) {
			return;
		}

		setLines(splitHeading.words);
		setLines(splitDescr.lines);

		TweenMax.set($icon, {
			autoAlpha: 0,
			y: '30px'
		});

	}

	this.animate = function () {

		if (!$target.length) {
			return;
		}
		tl.staggerTo($icon, 0.6, {
			autoAlpha: 1,
			y: '0px',
			ease: Power4.easeOut
		}, 0.05)
		tl.add(animateLines(splitHeading.words), '-=0.6')
		tl.add(animateLines(splitDescr.lines), '-=0.6')

		createOSScene($target, tl);

	}

}
